class CommunicationStorage {
  private userAccessToken: string | null = null;
  private cultureName: string | null = null;

  setUserAccessToken(userAccessToken: string) {
    this.userAccessToken = userAccessToken;
  }

  getUserAccessToken(): string | null {
    return this.userAccessToken;
  }

  setCultureName(cultureName: string) {
    this.cultureName = cultureName;
  }

  getCultureName(): string | null {
    return this.cultureName;
  }
}

export default new CommunicationStorage();
